import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Mumbaitolonavalacab() {



    const cardData = {

keyword: "Mumbai to Lonavala Cab",

headingDescription:
    "Mumbai Airport Cab offers safe, comfortable, and reliable Mumbai to Lonavala Cab services for families, couples, corporate travelers, weekend getaways, sightseeing tours, and group outings. We provide well-maintained Sedan, SUV, Innova Crysta, Ertiga, Tempo Traveller, Luxury Urbania, and Mini Bus options with experienced chauffeurs for a smooth journey via the Mumbai-Pune Expressway. With doorstep pickup across Mumbai, Mumbai Airport transfers, one-way and round-trip cab bookings, customized sightseeing packages, 24/7 customer support, and transparent pricing, we ensure a memorable and hassle-free trip to the scenic hill station of Lonavala, famous for its lush valleys, waterfalls, historic forts, and pleasant climate.",

topPlaces: [
    {
        title: "Tiger Point",
        description:
            "Tiger Point is one of the most popular viewpoints in Lonavala, offering breathtaking panoramic views of the Sahyadri Mountains and deep valleys. During the monsoon season, the area transforms into a green paradise with flowing waterfalls and mist-covered hills. Visitors enjoy photography, local snacks, sunrise and sunset views, and the refreshing mountain air, making it an essential stop during a Mumbai to Lonavala cab trip."
    },
    {
        title: "Bhushi Dam",
        description:
            "Bhushi Dam is among Lonavala's most visited attractions and becomes especially lively during the monsoon months. Tourists gather to enjoy the overflowing water, scenic surroundings, and cool weather while spending quality time with family and friends. The nearby food stalls and picturesque landscapes make it a perfect destination for relaxation and memorable holiday experiences."
    },
    {
        title: "Karla Caves",
        description:
            "Karla Caves are ancient Buddhist rock-cut caves dating back more than two thousand years and are known for their impressive architecture and historical significance. The magnificent prayer hall, detailed carvings, and ancient inscriptions attract history enthusiasts and pilgrims alike. Visitors also enjoy panoramic views of the surrounding hills after climbing the steps leading to the caves."
    },
    {
        title: "Bhaja Caves",
        description:
            "Bhaja Caves are an important group of ancient Buddhist monuments featuring beautifully carved chaityas, viharas, and sculptures. Surrounded by green hills and waterfalls during the rainy season, the caves provide a peaceful atmosphere for exploration and photography. Their historical importance and scenic location make them a favorite attraction near Lonavala."
    },
    {
        title: "Rajmachi Fort",
        description:
            "Rajmachi Fort is a historic hill fort nestled in the Sahyadri ranges and is famous for its trekking routes, scenic landscapes, and Maratha history. The twin forts of Shrivardhan and Manaranjan offer spectacular views of the valleys and forests below. Adventure lovers and history enthusiasts enjoy visiting this iconic destination throughout the year."
    },
    {
        title: "Lohagad Fort",
        description:
            "Lohagad Fort is one of Maharashtra's best-preserved hill forts and is closely associated with Chhatrapati Shivaji Maharaj. The fort features ancient gateways, massive walls, and the famous Vinchu Kata formation that offers breathtaking views of the surrounding countryside. The easy trekking route and historical significance make it an ideal destination for families and tourists."
    },
    {
        title: "Pawna Lake",
        description:
            "Pawna Lake is a beautiful artificial reservoir surrounded by rolling hills, green landscapes, and historic forts. It has become a popular destination for camping, boating, picnics, and lakeside relaxation. Visitors enjoy peaceful evenings, stargazing, and scenic photography while experiencing the natural beauty of the Lonavala region."
    },
    {
        title: "Della Adventure Park",
        description:
            "Della Adventure Park is one of India's leading adventure destinations, offering a wide range of activities for visitors of all ages. The park features adventure rides, ATV experiences, zip lines, paintball, luxury accommodations, and entertainment zones. Families, corporate groups, and adventure seekers enjoy spending an exciting day at this world-class attraction."
    },
    {
        title: "Duke's Nose",
        description:
            "Duke's Nose is a dramatic cliff and popular trekking destination named for its resemblance to the Duke of Wellington's nose. The viewpoint offers stunning panoramic views of the Western Ghats, deep valleys, and the Mumbai-Pune route below. Adventure enthusiasts visit for trekking, rock climbing, photography, and enjoying the region's spectacular natural scenery."
    },
    {
        title: "Khandala",
        description:
            "Khandala, located adjacent to Lonavala, is a charming hill station famous for its lush green valleys, scenic viewpoints, waterfalls, and peaceful environment. Attractions such as Shooting Point, Sunset Point, and Amrutanjan Point offer magnificent views of the surrounding mountains and expressway. Many travelers combine Lonavala and Khandala sightseeing to enjoy a complete hill station experience during their Mumbai to Lonavala cab journey."
    }
],



services: [
{
name: "Mumbai to Lonavala Cab",
description: "Mumbai Airport Cab offers Mumbai to Lonavala Cab service for comfortable, safe, and affordable travel to one of Maharashtra's most popular hill stations. Whether you are planning a family vacation, weekend getaway, corporate outing, romantic trip, or sightseeing tour, we provide well-maintained AC Sedan, Ertiga, Innova Crysta, Kia Carens, SUV, Tempo Traveller, and luxury vehicles. Our professional chauffeurs ensure a smooth journey through the scenic Mumbai-Pune Expressway while offering doorstep pickup, flexible schedules, one way and round trip options, transparent pricing, and 24x7 booking support. Enjoy a relaxing ride to Lonavala with reliable transportation and premium travel comfort."
},
{
name: "Mumbai to Lonavala Taxi",
description: "Book Mumbai to Lonavala Taxi with Mumbai Airport Cab for convenient and hassle-free travel. Our experienced drivers, clean AC vehicles, affordable rates, and flexible pickup options make every journey comfortable for families, couples, and groups visiting Lonavala."
},
{
name: "Mumbai to Lonavala Taxi Fare",
description: "Get affordable Mumbai to Lonavala Taxi Fare with Mumbai Airport Cab. We provide transparent pricing, no hidden charges, multiple vehicle options, and cost-effective travel packages for one way and round trip journeys."
},
{
name: "Mumbai to Lonavala Cab Fare",
description: "Mumbai Airport Cab offers competitive Mumbai to Lonavala Cab Fare with reliable service, professional chauffeurs, comfortable vehicles, and convenient booking options for all types of travellers."
},
{
name: "Cab from Mumbai to Lonavala",
description: "Choose a Cab from Mumbai to Lonavala with Mumbai Airport Cab and enjoy a safe, comfortable, and scenic journey with experienced drivers and a fleet of premium AC vehicles."
},
{
name: "Cab Service from Mumbai to Lonavala",
description: "Mumbai Airport Cab provides Cab Service from Mumbai to Lonavala with Sedan, Ertiga, Innova Crysta, SUV, and luxury vehicle options suitable for family trips, corporate travel, and sightseeing tours."
},
{
name: "Mumbai to Lonavala Car Rental",
description: "Book Mumbai to Lonavala Car Rental with chauffeur-driven vehicles for a comfortable and flexible travel experience. We offer affordable packages for individuals, families, and groups."
},
{
name: "Mumbai to Lonavala Cab Booking",
description: "Mumbai Airport Cab offers Mumbai to Lonavala Cab Booking with instant confirmation, 24x7 customer support, professional drivers, and multiple vehicle choices for every travel requirement."
},
{
name: "Mumbai to Lonavala One Way Cab",
description: "Travel conveniently with Mumbai to Lonavala One Way Cab service featuring fixed pricing, comfortable AC vehicles, experienced chauffeurs, and hassle-free pickup and drop facilities."
},
{
name: "Mumbai to Lonavala Round Trip Cab",
description: "Mumbai Airport Cab provides Mumbai to Lonavala Round Trip Cab packages for same-day returns, weekend vacations, sightseeing tours, and family outings with flexible travel schedules."
},
{
name: "Mumbai to Lonavala Outstation Cab",
description: "Book Mumbai to Lonavala Outstation Cab for comfortable long-distance travel with professional drivers, premium vehicles, and customized travel packages designed for leisure and business travellers."
},
{
name: "Mumbai to Lonavala Taxi Service",
description: "Mumbai Airport Cab offers Mumbai to Lonavala Taxi Service with safe transportation, affordable fares, clean vehicles, and reliable chauffeurs for a stress-free journey."
},
{
name: "Mumbai to Lonavala Car Hire",
description: "Choose Mumbai to Lonavala Car Hire with Mumbai Airport Cab for premium chauffeur-driven travel with flexible schedules, comfortable seating, and personalized service."
},
{
name: "Mumbai to Lonavala Innova Cab",
description: "Mumbai Airport Cab provides Mumbai to Lonavala Innova Cab service with spacious seating, ample luggage capacity, and comfortable travel for families and small groups."
},
{
name: "Mumbai to Lonavala Ertiga Cab",
description: "Book Mumbai to Lonavala Ertiga Cab for economical and comfortable family travel with AC comfort, professional drivers, and affordable travel packages."
},
{
name: "Mumbai to Lonavala SUV Cab",
description: "Mumbai Airport Cab offers Mumbai to Lonavala SUV Cab service for larger families and groups seeking spacious interiors, premium comfort, and smooth travel."
},
{
name: "Mumbai to Lonavala Sedan Cab",
description: "Travel with Mumbai to Lonavala Sedan Cab for affordable and comfortable transportation suitable for couples, solo travellers, and small families."
},
{
name: "Mumbai Airport to Lonavala Cab",
description: "Book Mumbai Airport to Lonavala Cab with direct pickup from domestic and international terminals. We provide flight tracking, professional chauffeurs, luggage assistance, and comfortable AC vehicles."
},
{
name: "Navi Mumbai to Lonavala Cab",
description: "Mumbai Airport Cab offers Navi Mumbai to Lonavala Cab service with doorstep pickup, affordable fares, and comfortable travel options for leisure and business travellers."
},
{
name: "Thane to Lonavala Cab",
description: "Choose Thane to Lonavala Cab with Mumbai Airport Cab for reliable transportation, premium vehicles, experienced drivers, and flexible travel schedules."
},
{
name: "Mumbai to Lonavala Family Trip Cab",
description: "Mumbai Airport Cab provides Mumbai to Lonavala Family Trip Cab service with spacious vehicles, safe drivers, and customized travel plans designed for comfortable family vacations."
},
{
name: "Mumbai to Lonavala Weekend Cab",
description: "Book Mumbai to Lonavala Weekend Cab for a relaxing getaway with flexible pickup timings, premium vehicle options, and reliable chauffeur-driven transportation."
},
{
name: "Mumbai to Lonavala Tour Cab",
description: "Mumbai Airport Cab offers Mumbai to Lonavala Tour Cab service with sightseeing packages covering popular attractions, scenic viewpoints, waterfalls, lakes, and tourist destinations in and around Lonavala."
}
],

tableData: [
["Mumbai to Lonavala Cab","Mumbai to Lonavala Taxi"],
["Mumbai to Lonavala Taxi Fare","Mumbai to Lonavala Cab Fare"],
["Cab from Mumbai to Lonavala","Cab Service from Mumbai to Lonavala"],
["Mumbai to Lonavala Car Rental","Mumbai to Lonavala Cab Booking"],
["Mumbai to Lonavala One Way Cab","Mumbai to Lonavala Round Trip Cab"],
["Mumbai to Lonavala Outstation Cab","Mumbai to Lonavala Taxi Service"],
["Mumbai to Lonavala Car Hire","Mumbai to Lonavala Innova Cab"],
["Mumbai to Lonavala Ertiga Cab","Mumbai to Lonavala SUV Cab"],
["Mumbai to Lonavala Sedan Cab","Mumbai Airport to Lonavala Cab"],
["Navi Mumbai to Lonavala Cab","Thane to Lonavala Cab"],
["Mumbai to Lonavala Family Trip Cab","Mumbai to Lonavala Weekend Cab"],
["Mumbai to Lonavala Tour Cab","Mumbai to Lonavala Sightseeing Cab"]
],




whychoose: [
{
WhyChooseheading: "Reliable Mumbai to Lonavala Cab Service",
WhyChoosedescription: "Mumbai Airport Cab Service provides dependable Mumbai to Lonavala Cab transportation for families, couples, tourists, corporate travelers, and weekend vacationers seeking a comfortable journey."
},
{
WhyChooseheading: "Perfect Weekend Getaway Transportation",
WhyChoosedescription: "Lonavala is one of the most popular hill stations near Mumbai, and our cab service offers hassle-free travel for short vacations and leisure trips."
},
{
WhyChooseheading: "Comfortable and Scenic Travel Experience",
WhyChoosedescription: "Enjoy a pleasant drive through beautiful mountain landscapes, valleys, and expressway routes with our well-maintained vehicles."
},
{
WhyChooseheading: "Multiple Vehicle Options Available",
WhyChoosedescription: "Customers can choose Sedan cars, Ertiga, Innova Crysta, SUVs, Tempo Travellers, and luxury vehicles according to passenger count and travel requirements."
},
{
WhyChooseheading: "One-Way and Round Trip Facilities",
WhyChoosedescription: "Whether you need a one-way drop, same-day return, round trip, or customized sightseeing itinerary, we provide flexible travel options."
},
{
WhyChooseheading: "Pickup Available Across Mumbai",
WhyChoosedescription: "Doorstep pickup services are available from Mumbai Airport, Navi Mumbai, Thane, Andheri, Borivali, Dadar, Bandra, Powai, and nearby locations."
},
{
WhyChooseheading: "Safe and Professional Drivers",
WhyChoosedescription: "Our experienced drivers and regularly maintained vehicles ensure safe, comfortable, and stress-free travel throughout the journey."
},
{
WhyChooseheading: "Ideal for Families, Couples, and Groups",
WhyChoosedescription: "From romantic getaways to family vacations and corporate outings, we offer suitable vehicle options for every type of traveler."
}
]
};

const faqData = [
{
question: "Why do travelers frequently book Mumbai to Lonavala Cabs?",
answer: "Lonavala is a famous hill station known for its scenic beauty, waterfalls, viewpoints, pleasant weather, and weekend getaway attractions."
},
{
question: "Can I book a one-way cab from Mumbai to Lonavala?",
answer: "Yes, one-way cab services are available along with round-trip and customized sightseeing packages."
},
{
question: "Which vehicle is suitable for Mumbai to Lonavala travel?",
answer: "Sedan cars, Ertiga, and Innova Crysta are among the most popular choices for comfortable hill station travel."
},
{
question: "Are same-day return trips available?",
answer: "Yes, customers can choose same-day return travel depending on their sightseeing plans and schedule."
},
{
question: "Can families use this service for vacations?",
answer: "Yes, families frequently book Mumbai to Lonavala Cabs for holidays, picnics, and weekend trips."
},
{
question: "Do you provide Tempo Travellers for group travel?",
answer: "Yes, Tempo Travellers and larger vehicles are available for family groups, corporate outings, and group tours."
},
{
question: "Can customers start the journey from Mumbai Airport?",
answer: "Yes, pickup services are available from Mumbai Airport, railway stations, hotels, offices, and residential locations."
},
{
question: "Can sightseeing locations be included during the trip?",
answer: "Yes, customers can include Tiger Point, Bhushi Dam, Lion's Point, Karla Caves, Rajmachi Point, and other attractions."
},
{
question: "Is advance reservation recommended for Mumbai to Lonavala travel?",
answer: "Yes, advance booking helps secure preferred vehicles and ensures smooth travel planning."
},
{
question: "How can I book a Mumbai to Lonavala Cab?",
answer: "Bookings can be made through phone calls, WhatsApp messages, or online inquiries with Mumbai Airport Cab Service."
}
];

const testimonials = [
{
id: 1,
name: "Mr. Rohan Kulkarni",
feedback:
"We booked a Mumbai to Lonavala Cab for a weekend family trip. The vehicle was clean, comfortable, and the driver was very professional throughout the journey.",
rating: 5
},
{
id: 2,
name: "Mrs. Priyanka Shah",
feedback:
"Our Lonavala getaway was excellent with Mumbai Airport Cab Service. The pickup was on time, the cab was spacious, and the entire travel experience was smooth and enjoyable.",
rating: 5
}
];






























   const Images = [
    { place: "/images/keyword/114.jpg", text: "Mumbai Outstation Cabs", link: "Mumbai-Outstation-Cabs" },
    { place: "/images/keyword/113.jpg", text: "Mumbai to Mahabaleshwar Cab", link: "Mumbai-to-Mahabaleshwar-Cab" },
    { place: "/images/keyword/112.jpg", text: "Mumbai to Goa Cabs", link: "Mumbai-to-Goa-Cabs" },
    { place: "/images/keyword/111.jpg", text: "Mumbai to Shirdi Cab", link: "Mumbai-to-Shirdi-Cab" },
    { place: "/images/keyword/110.jpg", text: "Mumbai Nashik Cab", link: "Mumbai-Nashik-Cab" },
    { place: "/images/keyword/109.jpg", text: "Mumbai to Kolhapur Cab", link: "Mumbai-to-Kolhapur-Cab" },
    { place: "/images/keyword/108.jpg", text: "Mumbai to Pune Cab", link: "Mumbai-to-Pune-Cab" },
    { place: "/images/keyword/107.jpg", text: "Mumbai to Aurangabad Cab", link: "Mumbai-to-Aurangabad-Cab" },
    { place: "/images/keyword/106.jpg", text: "Mumbai to Bhimashankar Cab", link: "Mumbai-to-Bhimashankar-Cab" },
    { place: "/images/keyword/105.jpg", text: "Mumbai to Ashtavinayak Cab Service", link: "Mumbai-to-Ashtavinayak-Cab-Service" },
    { place: "/images/keyword/104.jpg", text: "Mumbai to 5 Jyotirlinga Cab", link: "Mumbai-to-5-Jyotirlinga-Cab" },
    { place: "/images/keyword/103.jpg", text: "Mumbai to Lonavala Cab", link: "Mumbai-to-Lonavala-Cab" },
    { place: "/images/keyword/102.jpg", text: "Mumbai to Konkan Darshan Cab Booking", link: "Mumbai-to-Konkan-Darshan-Cab-Booking" },
    { place: "/images/keyword/101.jpg", text: "Mumbai to Alibaug Cab", link: "Mumbai-to-Alibaug-Cab" },
    { place: "/images/keyword/100.jpg", text: "Mumbai to Ahmednagar Cab", link: "Mumbai-to-Ahmednagar-Cab" },
    { place: "/images/keyword/99.jpg", text: "Mumbai to Matheran Cab", link: "Mumbai-to-Matheran-Cab" },
    { place: "/images/keyword/98.jpg", text: "Mumbai to Jalgaon Cab Booking / Dhule", link: "Mumbai-to-Jalgaon-Dhule-Cab-Booking" },
    { place: "/images/keyword/97.jpg", text: "Mumbai to Lavasa Cab", link: "Mumbai-to-Lavasa-Cab" },
    { place: "/images/keyword/96.jpg", text: "Mumbai to Panchgani Cab", link: "Mumbai-to-Panchgani-Cab" },
    { place: "/images/keyword/95.jpg", text: "Mumbai to Khandala Taxi Fare", link: "Mumbai-to-Khandala-Taxi-Fare" },
    { place: "/images/keyword/94.jpg", text: "Mumbai to Surat Cab", link: "Mumbai-to-Surat-Cab" },
    { place: "/images/keyword/93.jpg", text: "Mumbai to Ahmedabad Cab", link: "Mumbai-to-Ahmedabad-Cab" },
    { place: "/images/keyword/92.jpg", text: "Mumbai to Narmada Parikrama Cab Booking", link: "Mumbai-to-Narmada-Parikrama-Cab-Booking" },
    { place: "/images/keyword/91.jpg", text: "Mumbai to Baroda Cabs", link: "Mumbai-to-Baroda-Cabs" },
    { place: "/images/keyword/90.jpg", text: "Mumbai to Daman Taxi", link: "Mumbai-to-Daman-Taxi" },
];













const productSchema = {
"@context": "https://schema.org",
"@type": "Product",
"name": "Mumbai to Lonavala Cab",
"image": "https://www.mumbaiairportcabs.com/assets/images/mumbai-to-lonavala-cab.jpg",
"description": "Book Mumbai to Lonavala cab service for a quick, comfortable, and scenic getaway. Mumbai Airport Cabs offers reliable taxi service with professional drivers, clean vehicles, transparent pricing, and flexible one-way and round-trip options for Lonavala trips.",
"brand": {
"@type": "Brand",
"name": "Mumbai Airport Cabs"
},
"aggregateRating": {
"@type": "AggregateRating",
"bestRating": "5",
"worstRating": "1",
"ratingValue": "4.8",
"ratingCount": "5471"
},
"offers": {
"@type": "Offer",
"priceCurrency": "INR",
"price": "Starting From ₹14/Km",
"availability": "https://schema.org/InStock",
"url": "https://www.mumbaiairportcabs.com/mumbai-to-lonavala-cab"
}
};





    return (
        <div>


<Helmet>
  <title>Mumbai to Lonavala Cab | Taxi Service & Fare | +91 9545731161</title>

<meta
 name="description"
 content="Book Mumbai to Lonavala cab service at affordable fares. Reliable taxi service with professional drivers, comfortable cars, and one-way and round-trip options for a smooth Lonavala trip."
/>

<meta
 name="keywords"
 content="mumbai to lonavala cab, mumbai to lonavala taxi, mumbai to lonavala taxi fare, mumbai to lonavala cab fare, cab from mumbai to lonavala, cab service from mumbai to lonavala, mumbai to lonavala car rental, mumbai to lonavala cab booking, mumbai to lonavala one way cab, mumbai to lonavala round trip cab, mumbai to lonavala outstation cab, mumbai to lonavala taxi service, lonavala cab from mumbai, lonavala taxi booking mumbai"
/>

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>

</Helmet>







            <div
                className="breadcumb-wrapper"
                style={{
                    backgroundImage: "url('/images/breadcumb/breadcumb-bg.jpg')",
                    backgroundSize: "cover",
                    backgroundPosition: "center",
                }}
            >
                <div className="container z-index-common">
                    <div className="breadcumb-content">
                        <h1 className="breadcumb-title">{cardData.keyword}</h1>
                    </div>
                </div>
            </div>


















            <section>
                <div className="container-fluid" >
                    <div className="row container-fluid">
                        <div className="col-12 col-md-7 bg-foootr">
                            <img src='/images/keyword/103.jpg' alt='img' className='img-fluid' />
                            <h3 className="py-1"
                                style={{
                                    color: '#1A4160', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >Mumbai Airport Cab: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="topPlaces">

                                <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                                {cardData.topPlaces.map((place, index) => (
                                    <article key={index} className="placeCard borderr" tabIndex="0">
                                        <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                                        <div className="placeBody">
                                            <h4 className="placeTitle">{place.title}</h4>
                                            <p className="placeDesc">{place.description}</p>

                                        </div>

                                        <span className="placeArrow" aria-hidden>›</span>
                                    </article>
                                ))}
                            </div>


                            <div className="services-section">
                                {cardData.services.map((service, index) => (
                                    <div key={index} className="service-row">
                                        {/* <div className="service-icon">
                      🚗
                    </div> */}
                                        <div>
                                            <h4 className="service-title">{service.name}</h4>
                                            <p className="service-desc">{service.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>


                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section" className="why-choose-section">


                                {/* Section Title */}
                                <h2 className="section-title text-white">
                                    Why Choose <span>Mumbai Airport Cabs</span>
                                </h2>


                                {/* Cards */}
                                <div className="cards-grid">
                                    {cardData.whychoose.map((item, index) => (
                                        <div key={index} className="why-card">
                                            <div className="icon-circle">{index + 1}</div>
                                            <h4 className="card-heading">{item.WhyChooseheading}</h4>
                                            <p className="card-desc">{item.WhyChoosedescription}</p>
                                        </div>
                                    ))}
                                </div>
                            </div>



                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Mumbai Airport Cabs </h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">

                                                <FaqSection
                                                    title=""
                                                    subtitle=""
                                                    items={faqData}
                                                />

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <TestimonialSectionKeyword
                                testimonials={testimonials}
                            />


                            <ContactShowcase keyword={cardData.keyword} />
                        </div>

                        <div className='col-12 col-md-4' >
                            <div className="routeList">
                                {Images.map((e, i) => {
                                    const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                                    const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                                    return (
                                        <a
                                            key={e.link || i}
                                            href={href}
                                            className="routeItem"
                                            aria-label={e.text}
                                            {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                                        >
                                            <div className="routeThumb">
                                                <img src={e.place} alt="" loading="lazy" />
                                            </div>

                                            <div className="routeMeta">
                                                <h6 className="routeTitle">{e.text}</h6>
                                                <span className="routeUnderline" />
                                            </div>

                                            <span className="routeArrow" aria-hidden>›</span>
                                        </a>
                                    );
                                })}
                            </div>




                            <div>
                                <FleetHighway />
                            </div>
                            <div className="pc-contact">
                                <h4 className="pc-title">Contact Information</h4>

                                <div className="pc-grid">
                                    {/* Phones */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-telephone-fill"></i>
                                            <span>Phone Numbers</span>
                                        </header>

                                        <div className="pc-list">
                                            <a href="tel:+919545731161" className="pc-call">+91 9545731161</a>
                                        </div>

                                        <div className="pc-cta">
                                            <a
                                                href="https://wa.me/919545731161"
                                                target="_blank"
                                                rel="noopener noreferrer"
                                                className="pc-whats"
                                            >
                                                <i className="bi bi-whatsapp"></i> WhatsApp
                                            </a>
                                            <a href="tel:+919545731161" className="pc-primary">
                                                Call Now
                                            </a>
                                        </div>
                                    </section>

                                    {/* Email */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-envelope-fill"></i>
                                            <span>Email</span>
                                        </header>

                                        <a href="mailto:booking@mumbaiairportcabs.com" className="pc-email">
                                            booking@mumbaiairportcabs.com
                                        </a>
                                    </section>

                                    {/* Address */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-geo-alt-fill"></i>
                                            <span>Address</span>
                                        </header>

                                        <address className="pc-address">
                                            <strong>Mumbai Airport Cabs</strong><br />

                                            SAWANT SADAN 05 Ramachandra cold drinks House,
                                            Near SBI Bank Nehru Road Opp Noble Medical,
                                            Vile Parle East Mumbai, 400057
                                        </address>
                                    </section>
                                </div>
                            </div>


                        </div>
                    </div>
                </div>
            </section>


        </div>
    );
}

export default Mumbaitolonavalacab;